{
  "corpus_version": "1",
  "scoring_version": "v6",
  "generated": { "elite_n": 0, "negative_n": 0 },
  "languages": {}
}
